import Auth0Injector from './Auth0Injector'
// import OidcInjector from './OidcInjector'
import AuthComponent from './AuthComponent'
const AuthInjector = ({ authConfiguration, children }) => {
  if (authConfiguration.isAuth0) {
    return (
      <Auth0Injector authConfiguration={authConfiguration}>
        <AuthComponent>{children}</AuthComponent>
      </Auth0Injector>
    )
  }
return <div>NOT IMPLEMENTERD.</div>;
  // return (
  //   <OidcInjector authConfiguration={authConfiguration}>
  //     <AuthComponent>{children}</AuthComponent>
  //   </OidcInjector>
  // )
}

export default AuthInjector
